module.exports = __webpack_public_path__ + "static/img/ozone.ada29ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shitang/ozone.png
// module id = +EV5
// module chunks = 6